export default {
  path: '',
  component: {
    template: '<router-view :key="$route.fullPath" />'
  },
  meta: {
    title: '用户管理',
    navbar: 'el-icon-user'
  },
  children: [
    ...require('./users/route').default,
    ...require('./admin-users/route').default
  ]
}
